import useAppSelector from 'hooks/shared/store/useAppSelector';
import { FC, PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authSelector } from 'selectors/modules/auth';
import { AuthStatus } from 'slices/modules/auth/authState';
import AppRoute from './AppRoute';

const ProtectedRoute: FC<PropsWithChildren> = ({ children }) => {
  const { status } = useAppSelector(authSelector);
  const location = useLocation();

  if (status === AuthStatus.Guest) {
    return <Navigate to={AppRoute.login} replace state={{ from: location }} />;
  }

  return (
    <>
      {children}
    </>
  );
};

export default ProtectedRoute;
